import React, { useState, useEffect } from "react";
import {Box, Grommet} from 'grommet';
import {embedDashboard} from "@superset-ui/embedded-sdk";
import { getLoginUrl } from '../../config/env.js';


const theme = {
  global: {
    colors: {
      brand: '#397aa3',
      'accent-1': 'white',
      'focus': '#ecedf3',
      "my-text-color": "",
      background: '#ecedf3',
    },
    font: {
      family: '',
      size: '18px',
      height: '20px',
      color:"#397aa3",
    },
    select: {
      options:{
        extend:{
          fontWeight:'bold',
        },
      },
    },
  },
  layer: {
    border: {
      radius: 'large',
      intelligentRounding: true,
    },
  },
};


const SupersetComp = (props) => {

    const [dashboardId,setDashboardId]=React.useState("");

  function loginToSuperset() {
    const accessToken = sessionStorage.getItem("accessToken");
    const url = window.location.hostname;
    const parts = url.split('.'); // Dividi la stringa in base al punto
    const domain = parts[0]; // Estrai

    console.log("[Superset] loginToSuperset chiamata");
    console.log("[Superset] accessToken presente:", !!accessToken);
    console.log("[Superset] domain:", domain);
    console.log("[Superset] userId:", sessionStorage.getItem("userId"));

    if (!accessToken) {
      console.error("[Superset] Token di accesso non trovato in sessionStorage.");
      return;
    }

    const apiUrl = getLoginUrl('/api/superset/login');
    console.log("[Superset] API URL:", apiUrl);

    const requestBody = {
      "user": sessionStorage.getItem("userId"),
      "tenant": domain,
    };
    console.log("[Superset] Request body:", JSON.stringify(requestBody));

    // Opzioni per la richiesta HTTP
    const requestOptions = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    };
    // Effettua la richiesta HTTP
    return fetch(apiUrl, requestOptions)
      .then((response) => {
        console.log("[Superset] Response status:", response.status);
        if (!response.ok) {
          throw new Error("Errore nella richiesta HTTP. Status: " + response.status);
        }
        return response.json();
      })
      .then((data) => {
        console.log("[Superset] Risposta backend completa:", JSON.stringify(data));
        console.log("[Superset] dashboardId ricevuto:", data.dashboardId);
        console.log("[Superset] token ricevuto:", data.token ? data.token.substring(0, 20) + "..." : "NESSUN TOKEN");
        setDashboardId(data.dashboardId);
        return data.token
      })
      .catch((error) => {
        console.error("[Superset] Errore durante la richiesta:", error);
      });
}




  React.useEffect(()=>{
      console.log("[Superset] useEffect triggered - dashboardId:", JSON.stringify(dashboardId));
      console.log("[Superset] REACT_APP_SUPERSET_DOMAIN:", process.env.REACT_APP_SUPERSET_DOMAIN);
      console.log("[Superset] mountPoint trovato:", !!document.getElementById("superset-container"));

      try {
         console.log("[Superset] Chiamata embedDashboard con id:", JSON.stringify(dashboardId));
         embedDashboard({
            id: dashboardId, // given by the Superset embedding UI
            supersetDomain: process.env.REACT_APP_SUPERSET_DOMAIN,
            mountPoint: document.getElementById("superset-container"), // any html element that can contain an iframe
            fetchGuestToken: () => {
              console.log("[Superset] fetchGuestToken invocata dal SDK");
              return loginToSuperset();
            },
            dashboardUiConfig: { // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
                hideTitle: true,
                filters: {
                  expanded: true,
                },
            },
          }).catch((e) => console.error("[Superset] ERRORE embedDashboard:", e)).then((val) => {
            console.log("[Superset] embedDashboard completato, val:", val);
            document.getElementById("superset-container").children[0].width = "100%";
            document.getElementById("superset-container").children[0].height = "100%";
          })
      } catch (e) {
        console.error("[Superset] ERRORE try/catch:", e);
      }
  },[dashboardId])


  return (
    <Grommet theme={theme} themeMode="dark" >
      <Box id={"superset-container"} height="100vh"></Box>
    </Grommet>
  );
}

export default SupersetComp;
